exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_OrgAssetContainer_3ac5Z9rH8OAtyIPJRdcMe1 {\n  display: flex;\n  flex-direction: column;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n\n.IA_OrgAssetItemsContainer_1CWahXgOgfMIK7eomYbSb7 {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.IA_OrgAssetErrorMessage_KX23lLCzePTZcPAXkXmp2 {\n  padding-top: 15px;\n  font-size: 16px;\n}", ""]);

// Exports
exports.locals = {
	"IA_OrgAssetContainer": "IA_OrgAssetContainer_3ac5Z9rH8OAtyIPJRdcMe1",
	"IA_OrgAssetItemsContainer": "IA_OrgAssetItemsContainer_1CWahXgOgfMIK7eomYbSb7",
	"IA_OrgAssetErrorMessage": "IA_OrgAssetErrorMessage_KX23lLCzePTZcPAXkXmp2"
};